var _rect, _rect2, _g, _g2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 69,
    viewBox: "0 0 130 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 10.7266,
    width: 122.909,
    height: 47.2727,
    rx: 23.6364,
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3118_94093",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 123,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 10.7266,
    width: 122.909,
    height: 47.2727,
    rx: 23.6364,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3118_94093)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3118_94093)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 10.7266,
    width: 122.909,
    height: 47.2727,
    rx: 23.6364,
    fill: "#1F2533"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.8772 24.9092L11.2602 25.9443L12.2953 26.3274L11.2602 26.7104L10.8772 27.7455L10.4941 26.7104L9.45898 26.3274L10.4941 25.9443L10.8772 24.9092Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8947 32.4727L28.2778 33.5078L29.3129 33.8908L28.2778 34.2739L27.8947 35.309L27.5117 34.2739L26.4766 33.8908L27.5117 33.5078L27.8947 32.4727Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6584 49.4902L15.0415 50.5254L16.0766 50.9084L15.0415 51.2915L14.6584 52.3266L14.2754 51.2915L13.2402 50.9084L14.2754 50.5254L14.6584 49.4902Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3848 35.3086L19.5125 35.6536L19.8576 35.7813L19.5125 35.909L19.3848 36.254L19.2572 35.909L18.9121 35.7813L19.2572 35.6536L19.3848 35.3086Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8223 41.9277L11.95 42.2728L12.2951 42.4005L11.95 42.5281L11.8223 42.8732L11.6947 42.5281L11.3496 42.4005L11.6947 42.2728L11.8223 41.9277Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4591 51.3818L22.6506 51.8994L23.1682 52.0909L22.6506 52.2824L22.4591 52.8L22.2676 52.2824L21.75 52.0909L22.2676 51.8994L22.4591 51.3818Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3118_94093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1681 32.4727L10.3596 32.9902L10.8772 33.1817L10.3596 33.3733L10.1681 33.8908L9.97656 33.3733L9.45898 33.1817L9.97656 32.9902L10.1681 32.4727Z",
    fill: "#DEE5F3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.14851 46.6543L6.27619 46.9993L6.62124 47.127L6.27619 47.2547L6.14851 47.5998L6.02083 47.2547L5.67578 47.127L6.02083 46.9993L6.14851 46.6543Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7852 44.7637L29.9129 45.1087L30.258 45.2364L29.9129 45.3641L29.7852 45.7091L29.6575 45.3641L29.3125 45.2364L29.6575 45.1087L29.7852 44.7637Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2755 20.1816L21.4031 20.5267L21.7482 20.6544L21.4031 20.782L21.2755 21.1271L21.1478 20.782L20.8027 20.6544L21.1478 20.5267L21.2755 20.1816Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36726 35.3086L2.49494 35.6536L2.83999 35.7813L2.49494 35.909L2.36726 36.254L2.23958 35.909L1.89453 35.7813L2.23958 35.6536L2.36726 35.3086Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4572 15.4551L35.8403 16.4902L36.8754 16.8733L35.8403 17.2563L35.4572 18.2914L35.0742 17.2563L34.0391 16.8733L35.0742 16.4902L35.4572 15.4551Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2033 24.9092L57.5864 25.9443L58.6215 26.3274L57.5864 26.7104L57.2033 27.7455L56.8203 26.7104L55.7852 26.3274L56.8203 25.9443L57.2033 24.9092Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.967 46.6553L44.35 47.6904L45.3852 48.0735L44.35 48.4565L43.967 49.4916L43.584 48.4565L42.5488 48.0735L43.584 47.6904L43.967 46.6553Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6934 27.7461L48.8211 28.0911L49.1662 28.2188L48.8211 28.3465L48.6934 28.6915L48.5658 28.3465L48.2207 28.2188L48.5658 28.0911L48.6934 27.7461Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9122 38.1465L45.0399 38.4915L45.3849 38.6192L45.0399 38.7469L44.9122 39.0919L44.7845 38.7469L44.4395 38.6192L44.7845 38.4915L44.9122 38.1465Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8751 33.4189L50.0666 33.9365L50.5842 34.128L50.0666 34.3196L49.8751 34.8371L49.6836 34.3196L49.166 34.128L49.6836 33.9365L49.8751 33.4189Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3118_94093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4767 24.9092L39.6682 25.4268L40.1858 25.6183L39.6682 25.8098L39.4767 26.3274L39.2852 25.8098L38.7676 25.6183L39.2852 25.4268L39.4767 24.9092Z",
    fill: "#DEE5F3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3118_94093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4571 38.1465L35.5848 38.4915L35.9298 38.6192L35.5848 38.7469L35.4571 39.0919L35.3294 38.7469L34.9844 38.6192L35.3294 38.4915L35.4571 38.1465Z",
    fill: "#DEE5F3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.0938 37.2012L59.2215 37.5462L59.5665 37.6739L59.2215 37.8016L59.0938 38.1466L58.9661 37.8016L58.6211 37.6739L58.9661 37.5462L59.0938 37.2012Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3653 18.292L54.493 18.637L54.838 18.7647L54.493 18.8924L54.3653 19.2374L54.2376 18.8924L53.8926 18.7647L54.2376 18.637L54.3653 18.292Z",
    fill: "#DEE5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6759 27.7461L31.8035 28.0911L32.1486 28.2188L31.8035 28.3465L31.6759 28.6915L31.5482 28.3465L31.2031 28.2188L31.5482 28.0911L31.6759 27.7461Z",
    fill: "#DEE5F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dii_3118_94093)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.0163,
    height: 39.0163,
    rx: 19.5081,
    transform: "matrix(-1 3.99602e-09 3.99602e-09 1 118.617 14.875)",
    fill: "#DEE5F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M98.6095 17.2204C90.6958 15.3283 82.7306 20.1466 80.733 28.0343L80.6507 28.3591C78.6266 36.3516 83.5491 44.451 91.5759 46.3349C99.6281 48.2247 107.729 43.1859 109.619 35.1337C111.49 27.1604 106.575 19.125 98.6095 17.2204Z",
    fill: "#1F2533",
    fillOpacity: 0.79
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3118_94093",
    x: 0.00195312,
    y: 10.7266,
    width: 122.908,
    height: 52.9452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.67273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.25455
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0903125 0 0 0 0 0.105719 0 0 0 0 0.141667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3118_94093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3118_94093",
    x: 9.26989,
    y: 32.2836,
    width: 1.79615,
    height: 1.79615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0945455,
    result: "effect1_foregroundBlur_3118_94093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3118_94093",
    x: 38.5785,
    y: 24.7201,
    width: 1.79615,
    height: 1.79615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0945455,
    result: "effect1_foregroundBlur_3118_94093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3118_94093",
    x: 34.7953,
    y: 37.9574,
    width: 1.32349,
    height: 1.32349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0945455,
    result: "effect1_foregroundBlur_3118_94093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dii_3118_94093",
    x: 62.5834,
    y: 0.693181,
    width: 67.3793,
    height: 67.3802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.83636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.09091
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717122 0 0 0 0 0.717122 0 0 0 0 0.717122 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3118_94093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3118_94093",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89091
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.747882 0 0 0 0 0.749977 0 0 0 0 0.754167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3118_94093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.89091
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3118_94093",
    result: "effect3_innerShadow_3118_94093"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTheme);
export default __webpack_public_path__ + "static/media/dark-theme.c289ea0d.svg";
export { ForwardRef as ReactComponent };